import { render, staticRenderFns } from "./aiCreateQues.vue?vue&type=template&id=f40abc4e"
import script from "./aiCreateQues.vue?vue&type=script&lang=js"
export * from "./aiCreateQues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports